import React from "react";
import Icon from "components/Common/Icon";
import { EXPANSION, getFormattedContentType, getTierSet, getS3TierSet, SEASON } from "../../../lib/wowHelpers";
import { getWowStatic } from "hooks/wow/getStaticData";
import SubtitleAndDescription from "../../Common/SubtitleAndDescription";

const TierSetContainer = (props) => {
  const { className, specName, heroSpecName, encounterType } = props;
  const tierSetData = getS3TierSet(className);

  const twoPieceStaticData = getWowStatic("spell", tierSetData.two_piece[heroSpecName]);
  const fourPieceStaticData = getWowStatic("spell", tierSetData.four_piece[heroSpecName]);

  return twoPieceStaticData && fourPieceStaticData ? (
    <div className="tier-set-container">
      <div className="content-section">
        <SubtitleAndDescription
          subtitle={`${heroSpecName} ${encounterType === "PvP" ? "PvP " : ""}Tier Set`}
          description={`${EXPANSION} Season ${SEASON} ${specName} ${className} ${getFormattedContentType(
            encounterType,
          )} Tier Set`}
          className="tier-set-subtitle"
        />
        <div className="tier-set-content">
          <div className="text">
            <span className="title">2-Set</span> - <Icon staticDataImg={twoPieceStaticData.img} iconSize="20px" />{" "}
            {twoPieceStaticData.description}
          </div>
          <div className="text">
            <span className="title">4-Set</span> - <Icon staticDataImg={fourPieceStaticData.img} iconSize="20px" />{" "}
            {fourPieceStaticData.description}
          </div>
        </div>
      </div>
    </div>
  ) : null;
};

export default TierSetContainer;
